<template>
  <div
    class="activity-image"
    :style="{ 'grid-template-columns': 'repeat(' + columnCount + ', 1fr)' }"
  >
    <div
      v-for="(item, index) in componentConfig.imgConfigList"
      :key="index"
      class="item sensors_exposure"
      sensorsname="PictureModuleExposure"
      :sensorsdata="
        JSON.stringify({
          moduleName: `${componentConfig.sort}|${componentConfig.type}`,
          contentName: `${componentConfig.title}`,
        })
      "
    >
      <img class="img" :src="item.url" alt="" @click="open(item.jumpLink)" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ActivityImage",
  props: {
    componentConfig: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      columnCount: this.componentConfig.imgMaxPerLine,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$exposure.sensorsExposure();
    });
  },
  methods: {
    open(link) {
      if (link) {
        this.$sensors.track("$WebClick", {
          $element_id: "sensor_bcop_image_click",
          moduleName: `${this.componentConfig.sort}|${this.componentConfig.type}`,
          contentName: `${this.componentConfig?.title}`,
        });
        window.location.href = link;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.activity-image {
  // margin: 0 8px;
  padding: 0 8px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 8px;
  padding-bottom: 24px;
  position: relative;
  text-align: center;
  margin: 0 auto;
  .adapt_pc_widescreen & {
    width: 1200px;
    padding-bottom: 40px;
  }
  .item {
    .img {
      width: 100%;
      // height: 100%;
      object-fit: cover;
      
    }
  }
}
</style>
